export default __webpack_public_path__ + "static/media/costing.50789bbe.svg";